import { Component, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { fuseAnimations } from '../../../../@fuse/animations';

@Component({
    selector: 'tb-dismissable-error',
    imports: [MatIcon, MatIconButton],
    templateUrl: './tb-dismissable-error.component.html',
    animations: fuseAnimations,
})
export class TbDismissableErrorComponent {
    fullErrorMessage = input.required<string>();
    onDismiss = output();
}
